import { render, staticRenderFns } from "./ContractsShell.vue?vue&type=template&id=bdd6d14c"
import script from "./ContractsShell.vue?vue&type=script&lang=js"
export * from "./ContractsShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports